import { isString } from 'lodash'
import React, { useMemo } from 'react'

import Popup, { IPopup, TPopupPosition } from '../Popup'

export interface ITooltip extends IPopup {
  tooltip?: React.ReactNode
  element?: React.ReactNode
  text?: string
  children?: React.ReactNode
  isPopover?: boolean
}

const Tooltip = (props: ITooltip): React.ReactElement => {
  const {
    tooltip = null,
    element = null,
    text = '',
    children = null,
    isPopover,
    placement,
    ...IPopup
  } = props

  const item = useMemo(
    () => tooltip || element || text,
    [tooltip, element, text],
  )

  if (!item) {
    return children as React.ReactElement
  }

  return (
    <Popup
      trigger={isString(children) ? <div>{children}</div> : children}
      inverted={!isPopover}
      placement={placement}
      position={placement as TPopupPosition}
      {...IPopup}
    >
      <div>{item}</div>
    </Popup>
  )
}

export default Tooltip
